import { durationText, durationUnit } from "../../utils/appHelper";

export const createDPOPayPurchaseCard = (data, is_subscription, options = {}) => {
  const { isLoggedIn = false } = options;
  let is_single = true;
  if ($.type(data) == "array") {
    is_single = false;
  }
  let paymentDetails = "";
  let plans_field = "";

  const paymentForm = document.createElement('div');
  paymentForm.className = 'payment-form';

  if (is_single) {
    if (is_subscription) {
      const singlePlan = data[0];
      const subPlanPrice = validateDiscountPrice(singlePlan.discount, singlePlan.discount_valid_to) ? singlePlan.discount : singlePlan.price;
      paymentDetails = `
        <p class="purchase-card-title">SUBSCRIPTION</p>
        <p class="purchase-card-video-title" style="margin-bottom: 0;padding: 0px;">${
          data.title
        }</p>
        <p class="purchase-card-video-title" style="margin-bottom: 0;padding-bottom: 0;">Subscribe now to watch this content</p>
        ${
          data.trial_in
            ? '<p class="purchase-card-video-title" style="margin-bottom: 0;padding-bottom: 0;">Free Trial: ' +
              durationText(data.trial_in) +
              "</p>"
            : ""
        }
        ${
          '<p class="purchase-card-price price-p" style="text-align:center;">' + subPlanPrice + 
          '<span class="purchase-card-video-title" style="color: black;padding: 0px;">(per ' + durationUnit(singlePlan.expires_in) + ')<span></p>'
        }
      `;
    } else {
      paymentDetails = `
        <p class="purchase-card-title">PAY PER VIEW</p>
        <p class="purchase-card-video-title">${data?.title}</p>
        <p class="purchase-card-price" style="text-align:center;padding-top:0px">$${data?.price}</p>
      `;
    }
  } else {
    paymentDetails = `<p class="purchase-card-title">${
      is_subscription ? "SUBSCRIPTION" : "PAY PER VIEW"
    }</p>
    <p class="purchase-card-video-title">${
      is_subscription ? "Subscribe now to watch this content" : data.title
    }</p>`;
    plans_field = `<div class="form-row plans_dropdown ${
      data.length === 1 ? "select-single" : ""
    }" style="margin-top:10px">
      <label for="${
        is_subscription && data.length === 1 ? data[0].title : "Plans"
      }">${is_subscription && data.length === 1 ? data[0].title : "Plans"}</label>
      <select name="plan_id" style="width:100%" id="plan_value">`;

    data.forEach(function (val, index) {
      const subPlanPrice = validateDiscountPrice(val.discount, val.discount_valid_to) ? val.discount : val.price;
      const truncatedDescription = val.description && val.description.length > 40
        ? val.description.substring(0, 40) + "..."
        : val.description;
      plans_field += `<option value="${val.uuid}" data-price="${subPlanPrice}" ${
        index === 0 ? "selected" : ""
      }>${val.title} 
      ${subPlanPrice == 0 ? '' : ` (${subPlanPrice} per ${durationUnit(val.expires_in)})`}
      ${truncatedDescription ? ` - ${truncatedDescription}` : ''}
        </option>`;
    });

    plans_field += `</select></div>`;
  }
  
  function validateDiscountPrice(discountedPrice, discountValidity) {
    try {
        // Convert the discountValidity string into a Date object
        const validityDate = new Date(discountValidity);
        
        // Get today's date and reset the time part to compare only the date
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Remove the time part from the date for an accurate comparison
        
        // Check if discounted price validity date
        if (validityDate < today) {
          return false;
        }
        
        // Check if discount and regularPrice are not undefined
        if (typeof discountedPrice === 'undefined') {
            throw new Error("Discount value is undefined.");
        }
        
        // Convert the discount string to a float
        const discount = parseFloat(discountedPrice);

        // Validate if the discount is a valid number
        if (isNaN(discount)) {
            throw new Error("Invalid discount value. Please provide a numeric value.");
        }

        return discount > 0;
    } catch (error) {
        console.error(error.message);
        return "An error occurred during validation.";
    }
  }

  return `
    <div class="modal" id="DPOPayPurchaseCard" style="display: flex;align-items: center; justify-content: center;">
      <style>
        label{
          font-size: 15px;
          margin-bottom: 0px;
        }
        #card-element {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;
        }
        
        .DPOPayElement {
          width: 100%;
          padding: 10px;
          font-size: 16px;
          line-height: 24px;
          border: 1px solid #ccc;
          border-radius: 0px;
          height: 45px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .DPOPayElement .__PrivateDPOPayElement{
          width:100%;
        }
        
        .DPOPayElement--focus {
          border-color: #000;
        }
        #coupon_code, #email, #first_name, #last_name, #plan_value, #user_name, #password {
          font-size: 16px;
          line-height: 24px;
          border: 1px solid #ccc;
          border-radius: 4px;
          padding: 10px;
        }
        #dpo-pay-card-errors{
          margin-top: 20px;
          text-align: left;
          color: red;
          font-size: 16px;
          margin-bottom: 10px;
        }
        .purchase-card-price{
          padding: 10px;
          margin-bottom: 0px;
          font-size: 26px;
        }
        .coupon_apply_btn {
          outline: none;
          border: none;
          background: black;
          color: white;
          font-size: 18px;
          font-weight: 400;
          padding: 10px 20px;
        }

        #form-Info-Box .col{
          display: flex;
          justify-content: center;
          align-items: start;
          flex-direction: column;
        }
        /* For a single plan, hide the dropdown arrow */
        .plans_dropdown.select-single select {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          background-image: none;
          pointer-events:none;
        }
        .coupon_field{
          margin-top:14px;
        }
        .purchase-card{
          width:500px;
          font-family: Roboto, Arial, Helvetica, sans-serif;
        }
        .purchase-card input, .purchase-card select{
          border-radius:0px!important;
        }
        .coupon_field .colOne{
          width: 75%;
          margin: auto;
          margin-left: 0;
          display: flex;
          justify-content: center;
          align-items: center;      
        }
        .coupon_field .colTwo{
          width:24%;
          margin: auto;
          margin-right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
      
        }
        .coupon_field .colTwo button{
          width:100%;
        }
        @media screen and (max-width:601px){
          .purchase-card{
            width:90%!important;
          }
          .purchase-card label{
            font-size:12px;
          }
          .purchase-card input, .purchase-card select{
            padding:6px!important;
            font-size: 12px!important;
          }
          .purchase-card #form-Info-Box{
            display:block;
            margin-top:10px!important;
          }
          .purchase-card #form-Info-Box .col{
            padding: 2px 0px;
          }
          .purchase-card .purchase-card-video-title{
            font-size: 14px!important;
            padding: 4px 0px 06px 0px;
          }
          .purchase-card .price_details .purchase-card-title{
            font-size: 20px!important;
          }
          .purchase-card #dpo-pay-payment-form{
            padding:0px 20px!important;
          }
          .coupon_field .colOne, .coupon_field .colTwo{
            width:100%;
          }
          .coupon_field .colTwo button{
            width:100%;
            margin:6px auto;
            font-size: 14px;
          }
          button#dpo-pay-submit-payment{
            font-size: 14px;
          }
          .secndCol{
            margin-top:8px;
          }
          .purchase-card input::placeholder{
            font-size:12px;
          }
          .purchase-card #dpo-pay-card-errors{
            font-size: 12px;
            margin-top:10px;
          }
          .purchase-card button#dpo-pay-submit-payment{
            margin-bottom: 10px;
          }
          .purchase-card .alreadyAccount{
            text-align: center;
            font-size: 12px;
            margin-bottom: 30px;
          }
          .purchase-card .alreadyAccount a{
            font-weight: bold;
            font-size: 12px;
          }
          .purchase-card .DPOPayElement{
            height:auto;
          }
           .purchase-card-price{
          padding: 10px;
          margin-bottom: 0px;
          font-size: 16px;
        }
        #DPOPayPurchaseCard{
          width: 98%;
          display: flex;
          align-items: flex-start!important;
          margin: 24px auto;
          left:0;
          right:0;
        }
        }
        @media screen and (max-width:1025px) and (min-width:601px){
          #DPOPayPurchaseCard{
            width: 98%;
            display: flex;
            align-items: flex-start!important;
            margin: 24px auto;
            left:0;
            right:0;
            top:120px;
          }
        }
        .closeDPOPayPurchaseCardBox{
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding-right: 20px;
          margin-top: 10px;
        }
        .closeDPOPayPurchaseCardBox #closeDPOPayPurchaseCard{
          position: unset;
          width: 30px;
          color:#000000;
        }
        .purchase-card .purchase-card-title{
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          padding: 0px;
          margin-top: 0px;
          margin-bottom:0px;
          letter-spacing: 3px;  
        }
        .purchase-card .purchase-card-video-title{
          font-size:18px;
          font-weight:400;
          margin-bottom:0px!important;
        }
       .purchase-card .purchase-card-buy-now-container{
          margin:0px;
        }
        .purchase-card .form-row{
          margin:0px;
        }
        .purchase-card-buy-now{
          margin-bottom: 30px;
        }
        .purchase-card button {
          border-radius: 0px;
          margin: 0px auto;
          box-shadow:0px 0px 4px 0px #aaa;
        }
        button#dpo-pay-submit-payment{
          width:90%;
          margin-bottom: 20px;
        }
        #dpo-pay-payment-form a{
          text-decoration: none!important;
          color: #000000;
        }

        .form-row.DPOPayFieldBox {
          margin-top: 10px;
        }
        
        .alreadyAccount{
          text-align: center;
          font-size: 16px;
          margin-bottom: 30px;
        }
        .alreadyAccount a{
          font-weight: bold;
          font-size: 16px;
        }
        
        /* Spacer for logged-in users */
        .form-spacer {
          margin-bottom: 20px;
        }
        
        .card-number-wrapper .icon, .card-number-wrapper .card-type-icon, .name-wrapper .icon, .expiry-wrapper .icon, .cvc-wrapper .icon {
          top: 4px !important; 
        }
        .card-number-wrapper .card-type-icon {
          top: 17px !important;
        }
        .card-js .cvc-wrapper .cvc, .card-js .expiry-wrapper .expiry {
          display: inline;
        }
        .description {
          font-size: 12px;  /* Make the font smaller */
          color: #666;      /* Change the font color (gray here, change as needed) */
        }
      </style>

      <div class="purchase-card">
       <div  class="closeDPOPayPurchaseCardBox"> 
       <span id="closeDPOPayPurchaseCard" class="close-purchase-card">&times;</span></div>
        <div class="price_details">${paymentDetails}</div>
        <div class="purchase-card-buy-now-container">
          <form id="dpo-pay-payment-form" style="width:100%;padding: 0px 30px;text-align:center;">

            <div class="plans_dropdown">${plans_field}</div>
            
            <div class="form-row" id="form-Info-Box" style="text-align: left;margin-top: 10px;">
              <div class="col" style="padding-left:0px">
                <label for="first_name">First Name</label>
                <input type="first_name" id="first_name" name="first_name" placeholder="Enter your first name" style="width:100%" required>
              </div>
              <div class="col secndCol" style="padding-right:0px">
                <label for="last_name">Last Name</label>
                <input type="last_name" id="last_name" name="last_name" placeholder="Enter your last name" style="width:100%" required>
              </div>
            </div>

            <div class="form-row" id="form-Info-Box" style="text-align: left;margin-top: 10px;">
              <div class="col" style="padding-left:0px">
              <label for="email">Email</label>
              <input type="email" id="email" name="email" placeholder="Enter your email" style="width:100%" required>
              </div>
              <div class="col secndCol" style="padding-right:0px">
                <label for="password">Password</label>
                <input type="password" id="password" name="password" placeholder="Enter your password" style="width:100%" required>
              </div>
            </div>
            <div class="coupon_field" id="coupon-field"></div>
            
            <div id="dpo-pay-card-errors" role="alert"></div>
          
            <button id="dpo-pay-submit-payment" class="purchase-card-buy-now" type="button">Proceed to Payment</button>

            ${!isLoggedIn ? '<p class="alreadyAccount">Already have an account? <a href="/sign-in">Login</a></p>' : '<div class="form-spacer"></div>'}
          </form>
        </div>
      </div>
    </div>
  `;
};
